import { EmployeeProfilePotentialOverviewSectionTranslation } from '@/assets/locales/views/employeeProfile/sections/potentialOverview/employeeProfile.potentialOverview.translation.pl.ts';

export const employeeProfilePotentialOverviewSectionTranslation: EmployeeProfilePotentialOverviewSectionTranslation =
  {
    content: {
      actionRequired: 'Fill in feedback status',
      careerPath: {
        label: 'Career Path',
        nextStep: 'Next Step',
        optionalStep: 'Optional Step',
      },
      feedback: {
        false: 'Not Received',
        form: {
          cancelButton: 'Cancel',
          description: 'Reason for not providing feedback',
          label: 'Update Feedback Status',
          sendNotProvidedButton: 'Not Received',
          sendProvidedButton: 'Received',
          submitNotFeedbackButton: 'Save',
        },
        label: 'Feedback Status',
        true: 'Received',
      },
      potential: {
        comment: 'Overview Comment',
        commentNotFound: 'No comment available',
        label: 'Leadership Potential',
        notFound: 'No leadership criteria assessments available',
      },
    },
    headerTitle: 'MDR Potential Overview Result',
    headerTitleShorter: 'MDR Potential Overview Result',
  };
